import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg";

export function Contact() {
  return (
    <Container id="contact">
      <header>
        <h2>Contact.sh</h2>
      </header>

      <div className="terminal-wrapper">
        <div className="terminal-header">
          <div className="dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className="title">ssh connect@oybekdev.uz</div>
        </div>
        <div className="terminal-body">
          <div className="line">
            <span className="command">$ ssh connect@oybekdev.uz</span>
          </div>
          <div className="line gray">Connecting to gateway... [DONE]</div>
          <div className="line gray">Authorization successful... [OK]</div>
          <div className="line empty"></div>
          <div className="line yellow">{">"} Available Endpoints:</div>
          <div className="line separator">
            -------------------------------------------
          </div>

          <div className="endpoint">
            <span className="label">[EMAIL]</span>
            <span className="arrow">{"->"}</span>
            <a href="mailto:oybekdevuz@gmail.com" className="value">
              <img src={emailIcon} alt="Email" />
              oybekdevuz@gmail.com
            </a>
          </div>

          <div className="endpoint">
            <span className="label">[PHONE]</span>
            <span className="arrow">{"->"}</span>
            <a href="tel:+998938376838" className="value">
              <img src={phoneIcon} alt="Phone" />
              (+998) 99 363 68 38
            </a>
          </div>

          <div className="line separator">
            -------------------------------------------
          </div>
          <div className="line">
            <span className="prompt">oybek@portfolio:~$</span>
            <span className="cursor"></span>
          </div>
        </div>
      </div>
    </Container>
  );
}
